(function () {
  function initSimpleAOS() {
    const items = document.querySelectorAll("[data-aos]");

    if (!items.length) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("aos-animate");
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -80px 0px",
      }
    );

    items.forEach(function (item) {
      item.classList.add("aos-init");

      const delay = item.getAttribute("data-aos-delay");
      const duration = item.getAttribute("data-aos-duration");

      if (delay) {
        item.style.transitionDelay = delay + "ms";
      }

      if (duration) {
        item.style.transitionDuration = duration + "ms";
      }

      observer.observe(item);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSimpleAOS);
  } else {
    initSimpleAOS();
  }
})();